"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _phrase = _interopRequireDefault(require("@insided/deprecated-libs/translationsUtils/phrase"));

var _classnames = _interopRequireDefault(require("classnames"));

var _OpenBookIcon = _interopRequireDefault(require("@insided/destination/icons/OpenBookIcon"));

var _OpenInNew = _interopRequireDefault(require("@insided/destination/icons/OpenInNew"));

var _htmlParser = _interopRequireDefault(require("@insided/deprecated-preact-components/utils/htmlParser"));

var ExternalSearchResultItem = function ExternalSearchResultItem(_ref) {
  var type = _ref.type,
      url = _ref.url,
      title = _ref.title,
      content = _ref.content,
      customClass = _ref.customClass,
      anchorRel = _ref.anchorRel,
      key = _ref.key,
      clickCallback = _ref.clickCallback;

  var parsedContent = _htmlParser.default.stripHtml(content);

  var parsedTitle = _htmlParser.default.stripHtml(title);

  return (0, _preact.h)("div", {
    role: "button",
    tabIndex: 0,
    onClick: function onClick() {
      return clickCallback();
    },
    className: (0, _classnames.default)('qa-topic-block', 'thread-list-item', 'topic-view', 'forum-list-view-spacing', customClass, "thread-list-item--".concat(type)),
    key: key
  }, (0, _preact.h)("div", {
    className: "thread-list-item--icon"
  }, (0, _preact.h)(_OpenBookIcon.default, {
    width: 24,
    height: 24
  })), (0, _preact.h)("div", {
    className: "thread-list-item--details"
  }, (0, _preact.h)("span", {
    className: "thread-list-item--index-label"
  }, (0, _preact.h)(_phrase.default, {
    m: "Forum",
    p: "federated.search.".concat(type)
  })), (0, _preact.h)("h4", {
    className: "thread-list-block__title"
  }, (0, _preact.h)("a", {
    className: "qa-topic-title thread-list-block__title-link",
    href: (0, _absoluteUrlRuntime.resolveUrl)(url),
    target: "_blank",
    rel: anchorRel
  }, parsedTitle, (0, _preact.h)(_OpenInNew.default, {
    width: 14,
    height: 14
  }))), (0, _preact.h)("p", {
    className: "thread-list-block__content qa-topic-content"
  }, (0, _preact.h)("a", {
    href: (0, _absoluteUrlRuntime.resolveUrl)(url),
    target: "_blank",
    rel: anchorRel
  }, parsedContent))));
};

var _default = ExternalSearchResultItem;
exports.default = _default;